import { Row, Col, Table } from "react-bootstrap";
import classes from "./createOrderApplication.module.scss";

const CreateAppOrderTableHead = ({ data }) => {
	const columnsConfig = {
		1: ["objective", "product", "lackDays", "doseX100L", "doseHa", "doseMachinery", "quantityMachinery", "totalExpense", "actions"],
		2: ["objective", "product", "doseHa", "totalExpense", "actions"],
		3: ["objective", "product", "lackDays", "doseX100L", "doseHa", "doseMachinery", "actions"],
		4: ["objective", "product", "doseHa", "totalExpense", "actions"],
		5: ["objective", "product", "doseHa", "totalExpense", "actions"],
	};

	const columnTitles = {
		objective: "Objetivo",
		product: (
			<>
				Producto <br />
				<small>Ingrese al menos 3 letras para buscar.</small>
			</>
		),
		lackDays: (
			<>
				Días <br /> Carencia
			</>
		),
		doseX100L: (
			<>
				Dosis (cc, g, Un) <br /> cada 100L
			</>
		),
		doseHa: (
			<>
				Dosis (L, Kg, Un) <br /> por Ha
			</>
		),
		doseMachinery: (
			<>
				Dosis (L, Kg, Un)
				<br /> por maquinada
			</>
		),
		quantityMachinery: "Maquinadas (Un)",
		totalExpense: `Gasto total (L, Kg, Un)`,
		actions: "",
	};

	const columnWidths = {
		objective: "15%",
		product: "25%",
		lackDays: "6%",
		doseX100L: "10%",
		doseHa: "10%",
		doseMachinery: "12%",
		quantityMachinery: "10%",
		totalExpense: "12%",
		actions: "5%",
	};

	const shouldHideColumn = (column, data) => {
		if (!data) return false;

		return false;
	};

	const columnsToRender =
		data && data.application_order_type_id ? (columnsConfig[data.application_order_type_id] || []).filter((column) => !shouldHideColumn(column, data)) : [];

	return (
		<Row className={classes.header_table}>
			<Col md={12} sm={12}>
				<Table className={classes.tableHead}>
					<thead>
						<tr>
							{columnsToRender.map((column) => (
								<th key={column} style={{ width: columnWidths[column] }}>
									{columnTitles[column]}
								</th>
							))}
						</tr>
					</thead>
				</Table>
			</Col>
		</Row>
	);
};

export default CreateAppOrderTableHead;
